const h2element = document.querySelector('h2');

if (h2element) {
  h2element.addEventListener('click', () => {
    const bioElement = h2element.closest('.team-card__grid__content').querySelector('.bio');
    if (bioElement) {
        bioElement.classList.toggle('active');
    }
  });
} else {
  console.error('h2element not found in the DOM');
}